var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question1-container"},[_c('span',{staticClass:"question1-text heading3"},[_vm._v(_vm._s(_vm.Question))]),_c('span',{staticClass:"bodySmall"},[_vm._v(_vm._s(_vm.Answer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }